import { useEffect, useRef } from "react";
import { useSidebar } from "../../context/SidebarContext";
import UserDropdown from "../../components/kilDashboard/header/UserDropdown";

const AdminHeader = () => {
  const { isExpanded, toggleSidebar, toggleMobileSidebar } = useSidebar();
  const inputRef = useRef(null);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if ((event.metaKey || event.ctrlKey) && event.key === "k") {
        event.preventDefault();
        inputRef.current?.focus();
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, []);

  return (
    <header className="sticky top-0 z-50 bg-gray-50 border-b border-gray-200">
      <div className="flex items-center justify-between px-4 py-3 lg:px-6">
        <button
          type="button"
          onClick={() => {
            if (window.innerWidth >= 1024) toggleSidebar();
            else toggleMobileSidebar();
          }}
          className="flex items-center justify-center w-10 h-10 text-gray-500 border rounded-lg lg:border"
          aria-label="Toggle Sidebar"
        >
          {isExpanded ? (
            <svg
              className="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M15 19l-4-4 4-4M19 19l-4-4 4-4"
              />
            </svg>
          ) : (
            <svg
              className="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M9 5l4 4-4 4M5 5l4 4-4 4"
              />
            </svg>
          )}
        </button>

        <div className="flex items-center gap-4 lg:justify-end lg:gap-6">
          <UserDropdown />
        </div>
      </div>
    </header>
  );
};

export default AdminHeader;
